import { styled } from '@mui/material/styles';
import { DialogTitle } from '@mui/material';
import { SessionTime } from 'components/DeliveryManager';

const PREFIX = 'DialogHeader';

const classes = {
  root: `${PREFIX}-root`,
  heading: `${PREFIX}-heading`,
};

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  [`& .${classes.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },

  [`& .${classes.heading}`]: {
    margin: 0,
    color: theme.colorTokens.onSurfaceTextHeadline,
    fontWeight: 700,
    fontSize: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
}));

export default function DialogHeader({ title }) {
  return (
    <StyledDialogTitle>
      <div className={classes.root}>
        <h3 className={classes.heading}>{title}</h3>
        <SessionTime />
      </div>
    </StyledDialogTitle>
  );
}
